import { CloseButton, Modal, Table } from "react-bootstrap";

interface GlossaryCheckModalProps {
  vehicleFileNumber: string;
  attributeWindows: string[];
  informationWindows: string[];
  onClose: (hasIncompleteAttributeWindows: boolean) => void;
  onClick: (name: string, isInformationWindow: boolean) => void;
}

function GlossaryCheckModal({
  vehicleFileNumber,
  attributeWindows,
  informationWindows,
  onClose,
  onClick,
}: GlossaryCheckModalProps) {
  return (
    <Modal
      show={true}
      size="lg"
      onHide={() =>
        onClose(
          attributeWindows.length !== 0 || informationWindows.length !== 0,
        )
      }
    >
      <Modal.Header>
        <Modal.Title>Glossary check for {vehicleFileNumber}</Modal.Title>
        <CloseButton
          onClick={() =>
            onClose(
              attributeWindows.length !== 0 || informationWindows.length !== 0,
            )
          }
        />
      </Modal.Header>
      <Modal.Body>
        <Table size="sm">
          <tbody>
            {informationWindows.map((iw) => (
              <tr
                key={iw}
                role="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onClick(iw, true);
                }}
              >
                <td>{iw} (info)</td>
              </tr>
            ))}
            {attributeWindows.map((aw) => (
              <tr
                key={aw}
                role="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onClick(aw, false);
                }}
              >
                <td>{aw} (component)</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
}

export default GlossaryCheckModal;
